/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(".tab-slider--body").hide();
  $(".tab-slider--body:first").show();
  
  $(".tab-slider--nav li").click(function() {
    $(".tab-slider--body").hide();
    var activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();
    if($(this).attr("rel") == "tab2"){
      $('.tab-slider--tabs').addClass('slide');
    }else{
      $('.tab-slider--tabs').removeClass('slide');
    }
    $(".tab-slider--nav li").removeClass("active");
    $(this).addClass("active");
  });

/**
 * Product Button Bottom Sticky
 * 
 */
// $.fn.isInViewport=function(){var s=$(this).offset().top,i=s+$(this).outerHeight(),t=$(window).scrollTop(),n=t+$(window).height();return i>t&&s<n},$(window).on("resize scroll",function(){if($(".newCLass_sticky").length>0)if($(".newCLass_sticky").isInViewport())$("#sticky__btns").css("position","unset");else{var s=$("#sticky__btns").offset().top;$(window).scrollTop()>=s?$("#sticky__btns").css("position","unset"):$("#sticky__btns").css("position","fixed")}});


/*
$('.pro_main_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite:false,
  asNavFor: '.pro_thumnail',
  responsive: [{
    breakpoint: 640,
    settings: {
      dots:true,
      adaptiveHeight: true
    }
  }]
});

$('.pro_thumnail').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.pro_main_slider',
  focusOnSelect: true,
  vertical: true,
  responsive: [{
    breakpoint: 640,
    settings: {
      vertical: false,

    }
  }]
});

var container = [];

// Loop over gallery items and push it to the array
$('.pro_main_slider').find('img').each(function() {
  var $link = $(this);
  var maxWidth = parseInt($link.data('max-width')),
      maxHeight = parseInt($link.data('max-height')),            
      maxDimension = ($(window).width < 750) ? 1200 : 1800,
      reduceFactor = 1.0;

  if (maxWidth >= maxHeight) {
    reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
  } else {
    reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
  }

  var requestedWidth = Math.floor(maxWidth / reduceFactor);
  var requestedHeight = Math.floor(maxHeight / reduceFactor);


  item = {
    src: $link.attr('src'),
    w: requestedWidth,
    h: requestedHeight,
    title: $link.attr('alt')
  };
  container.push(item);
});
*/

$('.Product__SlideshowNav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite:true,
  focusOnSelect: true,
  vertical: true
});

/*
jQuery(document).ready(function(){
  jQuery('.SizeSwatchList .SizeSwatch').click(function(){
    jQuery('.currSize').removeClass('currSize');
    jQuery(this).parent('li').addClass('currSize');
    jQuery('.buynow-overlay').hide();
  });
  
  $('.buynow-overlay').click(function(){
    if($('.SizeSwatchList').length > 0){
      if($('.currSize').length <= 0){
        alert('Please select size.');
        return false;
      }
    }
  });
  
});*/